module.exports = __webpack_public_path__ + "static/media/business-1817472_1920.824d5f15.jpg";